import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted } from "vue";
import * as FileSaver from "file-saver";
import { SYSADMIN_CONTACT } from "@/constants";
import { get_cookie } from "@/cookie";

// Computed properties

export default /*#__PURE__*/_defineComponent({
  __name: 'api_token',
  setup(__props) {

const sysadmin_contact = computed(() => {
  return SYSADMIN_CONTACT;
});

// Lifecycle
// istanbul ignore next
onMounted(() => {
  let token = get_cookie("token");
  if (token) {
    FileSaver.saveAs(new File([token], "agtoken"));
  } else {
    console.error("API token not found.");
  }
});

return { __sfc: true,sysadmin_contact }
}

})